import React from "react";

const TermsConditions = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      title: "Terms & Conditions",
      subtitle:
        "These Terms & Conditions govern the use of our insurance and financial advisory services.",

      s1: "Regulatory Compliance",
      s1d:
        "Our services comply with regulations set by the Monetary Authority of Singapore (MAS).",

      s2: "Scope of Services",
      s2d:
        "We provide advisory services for insurance, wealth management, and asset protection.",

      s3: "Client Responsibilities",
      s3d:
        "Clients must provide accurate and complete information during consultation.",

      s4: "Limitation of Liability",
      s4d:
        "We act as an intermediary and are not responsible for insurer decisions.",

      s5: "Confidentiality",
      s5d:
        "All data is handled according to Singapore PDPA regulations.",

      s6: "Amendments to Terms",
      s6d:
        "We may update these terms at any time.",

      s7: "Governing Law",
      s7d:
        "These terms are governed by the laws of Singapore.",
    },

    zh: {
      title: "条款与条件",
      subtitle:
        "本条款适用于我们的保险与财务咨询服务。",

      s1: "监管合规",
      s1d:
        "我们的服务符合新加坡金融管理局规定。",

      s2: "服务范围",
      s2d:
        "我们提供保险、财富管理与资产规划服务。",

      s3: "客户责任",
      s3d:
        "客户必须提供真实完整信息。",

      s4: "责任限制",
      s4d:
        "我们作为中介，不负责保险公司决定。",

      s5: "保密",
      s5d:
        "所有数据依照新加坡 PDPA 法规处理。",

      s6: "条款修改",
      s6d:
        "条款可能随时更新。",

      s7: "适用法律",
      s7d:
        "本条款受新加坡法律管辖。",
    },
  };

  return (
    <section className="bg-gray-50 py-12">
      <div className="max-w-5xl mx-auto px-6">

        {/* Heading */}
        <div className="text-center mb-10">

          <h1 className="text-4xl font-bold text-[#154059] mb-4">
            {text[lang].title}
          </h1>

          <p className="text-gray-600 max-w-3xl mx-auto">
            {text[lang].subtitle}
          </p>

        </div>


        <div className="bg-[#c09f7c33] shadow-lg p-8 space-y-8">

          <Block t={text[lang].s1} d={text[lang].s1d} />
          <Block t={text[lang].s2} d={text[lang].s2d} />
          <Block t={text[lang].s3} d={text[lang].s3d} />
          <Block t={text[lang].s4} d={text[lang].s4d} />
          <Block t={text[lang].s5} d={text[lang].s5d} />
          <Block t={text[lang].s6} d={text[lang].s6d} />
          <Block t={text[lang].s7} d={text[lang].s7d} />

        </div>

      </div>
    </section>
  );
};

export default TermsConditions;


function Block({ t, d }) {
  return (
    <div>
      <h2 className="text-2xl font-semibold text-[#154059] mb-3">
        {t}
      </h2>
      <p className="text-gray-700 leading-relaxed">
        {d}
      </p>
    </div>
  );
}